// Pure helpers for "has a newer build been uploaded?" — used by NewVersionBanner.
// CRA writes build/asset-manifest.json with files["main.js"] = "/static/js/main.<hash>.js".

export const mainJsFromManifest = (manifest) =>
  (manifest && manifest.files && manifest.files["main.js"]) || "";

// The bundle this page is actually running (from its own <script> tag).
// Note: under `npm start` there is no /asset-manifest.json (the dev server
// has no build output), so the caller's fetch fails and no banner can show
// during local dev — the guard is the failed fetch, not matching paths.
export const runningMainJs = (doc = document) => {
  const s = doc.querySelector('script[src*="/static/js/main."], script[src*="/static/js/bundle"]');
  if (!s) return "";
  try {
    return new URL(s.src, doc.baseURI).pathname;
  } catch {
    return "";
  }
};

export const isNewVersion = (running, latest) =>
  Boolean(running && latest && running !== latest);
